// extracted by mini-css-extract-plugin
var _1 = "UIUsR";
var _2 = "kSk_P";
var _3 = "cWO9d";
export { _1 as "columnLayout", _2 as "firstColumn", _3 as "linkColumn" }
